import centroid from "@turf/centroid";
import getAddressComponentFromPosition from "./getAddressComponentFromPosition";
import parseAddressComponents from "./parseAddressComponents";

export default async function getStateAndCounty(geoJSON) {
  const center = centroid({
    type: "FeatureCollection",
    features: geoJSON.data,
  });

  if (!center) {
    return {};
  }

  const { coordinates } = center.geometry;
  const addressComponents = await getAddressComponentFromPosition(coordinates[0], coordinates[1]);

  return parseAddressComponents(addressComponents);
}
